// Validate that a hex color is valid - with or without hash
export const validateHexColour = (colour: string) => {
  // Allow hash to be optional
  const regex = /^#?([0-9A-F]{3}){1,2}$/i;
  return regex.test(colour);
};

// Get the R,G,B values from a hex colour
export const hexToRGBValues = (hex: string) => {
  // Validate hex
  if (!validateHexColour(hex)) {
    throw new Error(`Invalid hex colour: ${hex}`);
  }

  // Remove hash if present
  if (hex[0] === "#") {
    hex = hex.slice(1);
  }

  // Handle shorthand hex
  if (hex.length === 3) {
    hex = hex
      .split("")
      .map((char) => char + char)
      .join("");
  }

  const r = parseInt(hex.slice(0, 2), 16);
  const g = parseInt(hex.slice(2, 4), 16);
  const b = parseInt(hex.slice(4, 6), 16);

  return [r, g, b];
};

// Convert hex string to rgba string
export const hexToRgba = (hex: string, alpha: number) => {
  if (alpha < 0 || alpha > 1) {
    throw new Error(`Alpha value must be between 0 and 1`);
  }
  const [r, g, b] = hexToRGBValues(hex);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

// Determines if text should be white or black based on the background color (hex)
export const isTextLight = (backgroundColour: string, threshold = 186) => {
  const [r, g, b] = hexToRGBValues(backgroundColour);
  const yiq = (r * 299 + g * 587 + b * 114) / 1000;
  return yiq < threshold;
};
